export enum forceUploadVerificationModalActions {
  Yes = 1,
  No,
}
